import { toFusionHubSource } from "./fusionHubSource.js";
import type { LegalEntity } from "src/common/service/nexus/endpoints/companyDomain/types";

export type IntegrationCompanies = {
	all: LegalEntity[];
	/**
	 * First by `key`, and nothing more — not the principal company, not the
	 * parent. The source system numbered these in whatever order it created
	 * them.
	 */
	primary: LegalEntity | null;
	additionalCount: number;
};

// WHY: sorting by name would let a derived name arriving on a later sync reorder the list and change which company leads.
const byKey = (a: LegalEntity, b: LegalEntity) => {
	const left = Number(a.key);
	const right = Number(b.key);
	if (Number.isInteger(left) && Number.isInteger(right)) {
		return left - right;
	}
	return a.key.localeCompare(b.key);
};

/**
 * The companies a data source covers. Matched on `source` rather than through
 * the Nexus integration link rows, because there is one link row per company
 * and looking up "the" link row is the bug this exists to remove.
 */
export const toIntegrationCompanies = (
	legalEntities: LegalEntity[],
	integrationId: number | string,
): IntegrationCompanies => {
	const source = toFusionHubSource(integrationId);
	const all = legalEntities
		.filter((legalEntity) => legalEntity.source === source)
		.sort(byKey);

	return {
		all,
		primary: all[0] ?? null,
		additionalCount: Math.max(all.length - 1, 0),
	};
};
